import { useState } from "react";
import "../styles/upcomingMovies.scss";
import "bootstrap-icons/font/bootstrap-icons.css";
import Title from './common/Title';
import { useNavigate } from 'react-router-dom';
import MovieCard from "./MovieCard";

const tabs = ["Upcoming", "Released"];

export default function UpcomingMovies({ uMovies, nMovies }) {
  const [activeTab, setActiveTab] = useState("Upcoming");
  const navigate = useNavigate();
  // pick correct movies list depending on tab
  const movies = activeTab === "Upcoming" ? uMovies : nMovies;

  return (
    <div className="upcoming-movies-container">
      <div className="container">
        {/* <Title text="UPCOMING MOVIES" /> */}
<Title text={activeTab === "Upcoming" ? "UPCOMING MOVIES" : "RELEASED MOVIES"} />
        <div className="upcoming-movies-tabs">
          {tabs.map((tab) => (
            <button
              key={tab}
              onClick={() => setActiveTab(tab)}
              className={`upcoming-movies-tab${activeTab === tab ? " active" : ""}`}
            >
              {tab} Movies
            </button>
          ))}
        </div>

        {/* Desktop Grid */}
        <div className="d-none d-md-flex row">
          {movies && movies.map((movie) => (
            <div key={movie.id} className="col-md-3 d-flex justify-content-center">
              <MovieCard movie={movie} />
            </div>
          ))}
        </div>

        {/* Mobile Carousel */}
        <div className="d-md-none">
          <div id="mobileMovieCarousel" className="carousel slide" data-bs-ride="carousel">
            <div className="carousel-inner">
              {movies && movies.map((movie, index) => (
                <div
                  key={movie.id}
                  className={`carousel-item ${index === 0 ? 'active' : ''}`}
                >
                  <MovieCard movie={movie} />
                </div>
              ))}
            </div>
            <button className="carousel-control-prev" type="button" data-bs-target="#mobileMovieCarousel" data-bs-slide="prev">
              <span className="carousel-control-prev-icon" aria-hidden="true"></span>
            </button>
            <button className="carousel-control-next" type="button" data-bs-target="#mobileMovieCarousel" data-bs-slide="next">
              <span className="carousel-control-next-icon" aria-hidden="true"></span>
            </button>
          </div>
        </div>

        <div className="upcoming-movies-viewall-row">
          <button className="upcoming-movies-viewall-btn" onClick={() => navigate("/movies")}>View All</button>
        </div>
      </div>
    </div>
  );
}

